export const CARD_SCALES = {
  S: 0.8,
  M: 1,
  L: 1.24,
};

export const TEAM_PALETTE = [
  "#7FA2FF", "#FF7AB8", "#B79CFF", "#5FE3A8", "#FFC65C",
  "#FF9770", "#FF6B6B", "#67E8F9", "#EDE9DF", "#A3E635",
];

export const DEPARTMENTS = {
  Executive: { color: "#EDE9DF", label: "Executive" },
  Engineering: { color: "#7FA2FF", label: "Engineering" },
  Design: { color: "#FF7AB8", label: "Design" },
  Product: { color: "#B79CFF", label: "Product" },
  People: { color: "#5FE3A8", label: "People" },
  Finance: { color: "#FFC65C", label: "Finance" },
  Marketing: { color: "#FF9770", label: "Marketing" },
};

export const EXTRA_SWATCHES = ["#FF6B6B", "#67E8F9"];

export function deptColor(dept) {
  return DEPARTMENTS[dept]?.color ?? "#9CA3AF";
}

export const DEFAULT_TEAMS = Object.entries(DEPARTMENTS).map(([name, v]) => ({
  name,
  color: v.color,
}));

export function teamColor(teams, name) {
  return teams.find((t) => t.name === name)?.color ?? "#9CA3AF";
}

const n = (id, name, role, department, parentId) => ({
  id, name, role, department, color: deptColor(department), parentId,
});

export const SEED_NODES = [
  n("ceo", "Ava Hartley", "Chief Executive Officer", "Executive", null),

  n("cto", "Noah Mercer", "Chief Technology Officer", "Engineering", "ceo"),
  n("cdo", "Sofia Lindqvist", "Chief Design Officer", "Design", "ceo"),
  n("cpo", "Daniel Osei", "Chief Product Officer", "Product", "ceo"),
  n("cpo2", "Maya Chen", "Chief People Officer", "People", "ceo"),
  n("cfo", "Luca Romano", "Chief Financial Officer", "Finance", "ceo"),
  n("vpm", "Zoe Laurent", "VP Marketing", "Marketing", "ceo"),

  n("vp-plat", "Elena Vasquez", "VP Platform Engineering", "Engineering", "cto"),
  n("vp-prod-eng", "Ken Watanabe", "VP Product Engineering", "Engineering", "cto"),

  n("infra", "Priya Nair", "Staff Infrastructure Engineer", "Engineering", "vp-plat"),
  n("sre", "Tomas Silva", "Site Reliability Lead", "Engineering", "vp-plat"),
  n("fe", "Julia Novak", "Senior Frontend Engineer", "Engineering", "vp-prod-eng"),
  n("be", "Andre Baptiste", "Senior Backend Engineer", "Engineering", "vp-prod-eng"),

  n("brand", "Iris Fontaine", "Brand Design Lead", "Design", "cdo"),
  n("pd-lead", "Oliver Grant", "Product Design Lead", "Design", "cdo"),

  n("spm", "Hana Suzuki", "Senior Product Manager", "Product", "cpo"),
  n("gpm", "Marcus Bell", "Growth Product Manager", "Product", "cpo"),

  n("pops", "Nina Kowalski", "People Operations Lead", "People", "cpo2"),
  n("talent", "Ray Castillo", "Talent Acquisition Lead", "People", "cpo2"),

  n("fin", "Grace Adeyemi", "Financial Controller", "Finance", "cfo"),

  n("content", "Felix Braun", "Content Lead", "Marketing", "vpm"),
  n("perf", "Amara Sy", "Performance Lead", "Marketing", "vpm"),
];

export function initials(name) {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "") + (parts[parts.length - 1]?.[0] ?? "")).toUpperCase();
}
